import { render, staticRenderFns } from "./ConfiguracoesBroker.vue?vue&type=template&id=2c20abc2&scoped=true&"
import script from "./ConfiguracoesBroker.vue?vue&type=script&lang=js&"
export * from "./ConfiguracoesBroker.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracoesBroker.vue?vue&type=style&index=0&id=2c20abc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c20abc2",
  null
  
)

export default component.exports